// extracted by mini-css-extract-plugin
export var aircallIframe = "_ma-3";
export var fabContainer = "_ma-5";
export var fabRinging = "_ma-6";
export var loadingOverlay = "_ma-4";
export var pulse = "_ma-7";
export var widgetContent = "_ma-2";
export var widgetPanel = "_ma-0";
export var widgetPanelExpanded = "_ma-1";